import { RulesTable } from '@kw/quokka-ui';
import { useMemo, useState } from 'react';

import { useLocalStorage } from '../../../utils/useLocalStorage';
import { getEvidencesCallbackWithToken } from './utils/dopplerUtil';
import { getReviewActionOptions } from './utils/helper';
import { useFetchRuleSummaries } from './utils/useFetchRuleSummaries';
import { GuardianReviewModal } from './GuardianReviewModal';
import { AuthPermissions } from '../../../auth/AuthPermissions';
import { verifyAuthPermission } from '../../../auth/VerifyAuthPermission';

export const GuardianRulesTable = function GuardianRulesTable({ data, analysisId }: { data: object; analysisId: string }) {
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  const [ruleReviewModalMode, setRuleReviewModalMode] = useState(null);

  const canReview = verifyAuthPermission(AuthPermissions.REVIEW_APPLICATION);

  const ruleActionOptions = getReviewActionOptions(canReview, setRuleReviewModalMode);

  const [selectedRule, setSelectedRule] = useState({});

  const { reloadRuleSummariesData } = useFetchRuleSummaries(analysisId, {
    suspense: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  });

  // memoize the RulesTable component to prevent re-rendering when the parent component re-renders because of search bar updates
  // especially since the RulesTable component is a heavy component in terms of rendering time
  return useMemo(
    () => (
      <>
        <GuardianReviewModal
          mode={ruleReviewModalMode}
          setMode={setRuleReviewModalMode}
          analysisId={analysisId}
          selectedItem={selectedRule}
          fetchData={reloadRuleSummariesData}
          reviewType="rule"
          setLoading={() => {}}
          afterSaveArgs={[]}
        />
        <RulesTable
          ruleSummaries={data}
          uuid={analysisId}
          getEvidencesCallback={getEvidencesCallbackWithToken(accessToken)}
          ruleActionOptions={ruleActionOptions}
          setSelectedRule={setSelectedRule}
        />
      </>
    ),
    [data, analysisId, accessToken, ruleActionOptions],
  );
};
